import { fabric } from 'fabric';
import {
  isObjectLocked,
  setObjectLocked,
} from '@/components/Editor/helpers/fabric/lockObjects/lockObject';
import {
  FabricControl,
  FabricTransform,
} from '@/components/Editor/types/fabric';
import { actualCanvasIconSize, drawLockIcon } from './renderIcons';

export const getLockControl = (): FabricControl => {
  const canvasIconSize = actualCanvasIconSize();

  return new fabric.Control({
    cursorStyle: 'pointer',
    mouseDownHandler: (_, { target }: FabricTransform): void => {
      const isLocked = isObjectLocked(target);
      setObjectLocked({
        isLocked: !isLocked,
        object: target,
        shouldSaveInStore: true,
        isLockChildren: true,
      });

      target.canvas.requestRenderAll();
    },
    offsetY: canvasIconSize,
    render: drawLockIcon,
    sizeX: canvasIconSize,
    sizeY: canvasIconSize,
    x: 0,
    y: 0.5,
  });
};
